import { render, staticRenderFns } from "./bi-Bread.vue?vue&type=template&id=e0bd253c&scoped=true"
import script from "./bi-Bread.vue?vue&type=script&lang=js"
export * from "./bi-Bread.vue?vue&type=script&lang=js"
import style0 from "./bi-Bread.vue?vue&type=style&index=0&id=e0bd253c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bd253c",
  null
  
)

export default component.exports